<div>
    <div class="row m-0">
        <div class="col"></div>
        <div class="col-auto">
            <button *ngIf="this.common.PageRight.IsAdd" type="button" class="btn btn-primary" (click)="addTaxSection(0)"
                [disabled]="isDisabled">
                <i class="bi bi-plus-lg" *ngIf="!isDisabled"></i>
                <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"
                    *ngIf="isDisabled"></span>
                {{!isDisabled?'Add Tax Section':'Loading...'}}
            </button>
        </div>
    </div>
    <div class="card border-radius-0 mt-1 p-0">
        <div class="card-header">
            Tax Section Master
        </div>
        <div class="card-body p-1">
            <form class="g-3" name="FilterForm" (ngSubmit)="ESS_TaxSectionFYMasterSelect()" #FilterForm="ngForm"
                novalidate>
                <div class="row mx-1 mb-2">
                    <!-- <div class="col-md-3 px-1 pt-2">
                        <label>Financial Year Start</label>
                        <div class="input-group mb-3">
                            <input type="number" class="form-control" placeholder="Ex. 2024" id="FinancialYearStart"
                                name="FinancialYearStart" [(ngModel)]="Filter.YearStart" #FinancialYearStart="ngModel"
                                pattern="^[0-9]\d*$" (keypress)="common.NumberOnly($event)" maxlength="4"
                                (change)="SetFinancialYearEnd()">
                            <span class="input-group-text" id="Year">Year</span>
                        </div>
                    </div>
                    <div class="col-md-3 px-1 pt-2">
                        <label>Financial Year End</label>
                        <div class="input-group mb-3">
                            <input type="number" class="form-control" placeholder="Ex. 2025" id="FinancialYearEnd"
                                name="FinancialYearEnd" [(ngModel)]="Filter.YearEnd" #FinancialYearEnd="ngModel"
                                pattern="^[0-9]\d*$" maxlength="4" (keypress)="common.NumberOnly($event)" disabled>
                            <span class="input-group-text" id="Year">Year</span>
                        </div>
                    </div> -->
                    <!-- <div class="col-md-3 px-1 pt-2">
                        <label>Income Head</label>
                        <ng-select name="IncomeHead" [items]="IncomeHeads" bindLabel="Name" bindValue="value"
                            [(ngModel)]="Filter.IncomeHead" placeholder="Income Head">
                        </ng-select>
                    </div> -->
                    <div class="col-md-3 px-1 pt-2">
                        <label>Financial Year</label>
                        <ng-select name="ESS_TaxFinancialYearID" [items]="FinancialYears" bindLabel="FinancialYear"
                            bindValue="ESS_TaxFinancialYearID" [(ngModel)]="Filter.ESS_TaxFinancialYearID"
                            placeholder="Financial Year" (change)="clear()">
                        </ng-select>
                    </div>
                    <div class="col-md-3 px-1 pt-2">
                        <label>Regime</label>
                        <ng-select name="IsNewRegime" [items]="Regimes" bindLabel="Name" bindValue="value"
                            [(ngModel)]="Filter.Regime" placeholder="Regime" (change)="clear()">
                        </ng-select>
                    </div>
                    <div class="col"></div>
                    <div class="col-md-auto align-content-center">
                        <button class="btn btn-sm btn-primary" name="Filter">
                            <i class="bi bi-funnel"></i> Filter</button>
                    </div>
                </div>
            </form>
            <div class="row">
                <table datatable [dtOptions]="this.dtoptions" [dtTrigger]="dtTrigger"
                    class="customeDatatable table table-bordered">
                    <thead class="table-light">
                        <tr>
                            <th rowspan="2" style="width: 5px;" class="align-content-center">#</th>
                            <th rowspan="2" class="align-content-center"><span style="width: max-content;"
                                    class="d-block">Financial Year</span></th>
                            <th rowspan="2" style="width: 5px;" class="align-content-center"
                                [ngClass]="{'colHide': !this.common.PageRight.IsEdit}">
                                Action</th>
                            <th rowspan="2" class="align-content-center"><span style="width: max-content;"
                                    class="d-block">Section Code</span></th>
                            <th rowspan="2" class="align-content-center"><span style="width: max-content;"
                                    class="d-block">Section Name</span></th>
                            <!-- <th rowspan="2" class="align-content-center" style="width: 20px;"><span
                                    style="width: max-content;" class="d-block">IncomeHead</span></th>
                            <th rowspan="2" class="align-content-center"><span style="width: max-content;"
                                    class="d-block">Description</span></th> -->
                            <th colspan="3" class="text-center align-content-center">
                                Old Regime
                            </th>
                            <th colspan="3" class="text-center align-content-center">
                                New Regime
                            </th>
                        </tr>
                        <tr>
                            <th class="align-content-center"><span style="width: max-content;"
                                    class="d-block">Applicable</span></th>
                            <th class="align-content-center"><span style="width: max-content;" class="d-block">Max
                                    Limit</span></th>
                            <th class="align-content-center"><span style="width: max-content;"
                                    class="d-block">MaxAmount</span></th>
                            <th class="align-content-center"><span style="width: max-content;"
                                    class="d-block">Applicable</span></th>
                            <th class="align-content-center"><span style="width: max-content;" class="d-block">Max
                                    Limit</span></th>
                            <th class="align-content-center"><span style="width: max-content;"
                                    class="d-block">MaxAmount</span></th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr *ngFor="let TableData of TableDatas; let i = index">
                            <th scope="row" style="width: 5px;">{{i+1}}</th>
                            <td style="text-align:-webkit-right"><span style="width: max-content;"
                                    class="d-block">{{getFinancialYearDisplay(TableData['FinancialYearStart'],
                                    TableData['FinancialYearEnd'])}}</span></td>
                            <td style="width: 5px;" [ngClass]="{'colHide': !this.common.PageRight.IsEdit}">
                                <div class="text-center"><i
                                        (click)="addTaxSection(TableData['ESS_TaxSectionFYMasterId'])"
                                        class="bi bi-pencil-square text-warning"></i></div>
                            </td>
                            <td><span style="width: max-content;" class="d-block">{{TableData['SectionCode']}}</span>
                            </td>
                            <td style="width: 100%;"><span style="width: max-content;"
                                    class="d-block">{{TableData['SectionName']}}</span>
                            </td>
                            <!-- <td><span style="width: max-content;" class="d-block">{{TableData['IncomeHead']}}</span>
                            </td>
                            <td><span style="width: max-content;" class="d-block">{{TableData['Description']}}</span>
                            </td> -->
                            <td style="text-align:-webkit-center"><span style="width: max-content;"
                                    class="d-block">{{TableData['IsOldRegimeApplicable']?'Yes':'No'}}</span></td>
                            <td style="text-align:-webkit-center"><span style="width: max-content;"
                                    class="d-block">{{TableData['IsOldMaxlimitapplicable']?'Yes':'No'}}</span></td>
                            <td style="text-align:-webkit-right"><span style="width: max-content;"
                                    class="d-block">{{TableData['OldRegimeMaxAmount']}}</span></td>
                            <td style="text-align:-webkit-center"><span style="width: max-content;"
                                    class="d-block">{{TableData['IsNewRegimeApplicable']?'Yes':'No'}}</span></td>
                            <td style="text-align:-webkit-center"><span style="width: max-content;"
                                    class="d-block">{{TableData['IsNewMaxlimitapplicable']?'Yes':'No'}}</span></td>
                            <td style="text-align:-webkit-right"><span style="width: max-content;"
                                    class="d-block">{{TableData['NewRegimeMaxAmount']}}</span></td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>
        <div class="card-footer">
            <div class="row">
                <div class="col"></div>
                <div class="col-auto">
                    <button type="button" class="btn btn-primary mx-1" [disabled]="isDisabled" (click)="ExcelDump()"><i
                            *ngIf="!isDisabled" class="bi bi-download me-1"></i>
                        <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"
                            *ngIf="isDisabled"></span>
                        {{!isDisabled?'Excel':'Loading...'}}</button>
                </div>
            </div>
        </div>
    </div>
</div>